<template>

    <div v-if="error" class="flex h-screen justify-center items-center">
        <div class="m-auto">
            <p>{{error}}</p>
        </div>
    </div>
    <div v-else-if="loading" class="h-screen w-full">
        <div class="flex h-screen items-center">
            <vue-loaders
                name="ball-spin-fade-loader"
                color="#2a4365"
                class="flex m-auto my-4"
                scale="1"
            ></vue-loaders>
        </div>
    </div>
    <div v-else class="p-4  bg-gray-100 h-screen">
        <div class="flex-col">
            <div class="flex flex-wrap items-center mb-4 py-4 px-4 bg-gray-200 text-gray-700 hover:text-black shadow-lg cursor-pointer" @click="goBack">
                <ArrowLeftIcon class="mr-1 h-6 w-8 object-cover" ></ArrowLeftIcon>
                <p class="text-lg">Back</p>
            </div>
            <div class="flex py-3 px-3 text-gray-100 font-semibold text-xl tracking-wide uppercase underline text-center
             justify-center bg-blue-800 shadow-md">
                <p>{{announcement.title}}</p>
            </div>
        </div>

        <div class="px-3 py-6 text-left rounded shadow-md relative">
            <p class="text-base text-gray-800 tracking-tight leading-normal font-normal">

<!--                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et-->
<!--                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip-->
<!--                ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu-->
<!--                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia-->
<!--                deserunt mollit anim id est laborum.-->
                {{announcement.contents}}
            </p>
        </div>

        <div class="py-6 md:px-6 flex text-gray-700 text-base font-normal justify-between">
            <p>Announcer: <span class="text-gray-800 font-medium">{{announcement.announcer}}</span></p>
            <p>{{announcement.created_at | formatDateSlash}}</p>
        </div>
    </div>

</template>

<script>
    import {ArrowLeftIcon} from 'vue-feather-icons';
    // import router from '../js/routes';
    import Axios from 'axios';

    export default {
        name: "AnnouncementDetails",
        components: {ArrowLeftIcon},
        data: function(){
            return {
                announcement: {},
                error: {},
                loading: false,
            }
        },
        methods: {
            goBack: function(){
                // router.push({name: 'home'});

                this.$router.back();
            },

            getAnnouncementDetails: function(){
                this.loading = true;
                this.error = null;
                // let id = router.params.id;
                let id = this.$route.params.id;
                let token = localStorage.getItem('token');

                // console.log(id);
                // console.log(token);
                if(token === null){
                    this.router.push('/');
                    this.$swal('Please login');
                }else{
                    Axios.get(`/api/announcements/${id}`, {
                        headers: {'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`}
                    }).then(response => {
                        this.loading = false
                        console.log(response.data);
                        if(response.data.status === true){
                            this.announcement = response.data.data;
                        }else{
                            // this.error = '404: Not found';
                            this.router.push('/');
                            this.$swal('Please login');
                        }
                    }).catch(e => {
                        // this.error = e.toString();
                        e.toString();
                        this.error = 'Page not found';
                    })
                }

            }
        },
        created() {
            this.getAnnouncementDetails();
        }

    }
</script>

<style scoped>

</style>
